import React, { useRef, memo } from 'react';
import { useDrag, useDrop } from "react-dnd";

import { WithIdInterface } from '../Factor/models'


const DragItem = memo(({ id, onMoveItem, onDropItem, children }:
  { id: string, onMoveItem: (a, b) => {}, onDropItem: (a, b) => {}, children: any[] }) => {
  const ref = useRef(null);
  const type = '*'

  const collect = monitor => ({ isDragging: monitor.isDragging() })
  const item = { id, type }
  const [{ isDragging }, connectDrag] = useDrag({ item, collect })

  const [, connectDrop] = useDrop({
    accept: type,
    hover(hoveredOverItem: any) {
      if (hoveredOverItem.id !== id) {
        onMoveItem(hoveredOverItem.id, id);
      }
    },
    drop(hoveredOverItem: any) {
      onDropItem(hoveredOverItem.id, id);
    }
  });

  connectDrag(ref);
  connectDrop(ref);
  const opacity = isDragging ? 0.5 : 1;
  const containerStyle = { opacity };

  return React.Children.map(children, child =>
    React.cloneElement(child, {
      forwardedRef: ref,
      style: containerStyle
    })
  );
});


const DraggableCont = ({ children, ...props }) => {
  return (
    <DragItem {...props}>
      <GridItem>
        {children}
      </GridItem>
    </DragItem>
  )
}

const GridItem = ({ forwardedRef, ...props }) => (
  <div ref={forwardedRef} {...props} />
);

/**
 * @param itemList list of items with ids to map
 * @param render how items will be displayed
 * @param appendChildren if you need to add an item after mapped items
 * @param setItemList to update your itemList
 */
const DragContainer = <T extends WithIdInterface>({ itemList = [], render, appendChildren, setItemList = () => { }, dropItem = () => { } }:
  { itemList: T[], render: (descriptor: T, index?: number) => any, appendChildren: any, setItemList: (itemList: T[]) => void, dropItem: (itemList: T[]) => void }) => {

  const moveItem = (sourceId: string, destinationId: string): void => {
    if (!sourceId)
      return;
    const sourceIndex = itemList.findIndex(({ id }) => id === sourceId);
    const destinationIndex = itemList.findIndex(({ id }) => id === destinationId);
    const offset = destinationIndex - sourceIndex;
    setItemList(moveElement(itemList, sourceIndex, offset))
  };

  return (
    <>
      {itemList.map((itemInfo, index) => (
        <DraggableCont key={itemInfo.id} id={itemInfo.id} onMoveItem={moveItem} onDropItem={dropItem} on >
          {render(itemInfo, index)}
        </DraggableCont>
      ))}
      {appendChildren}
    </>
  )
}

export default DragContainer



const move = (array, oldIndex, newIndex): DragItem[] => {
  const result = [...array]
  const [removed] = result.splice(oldIndex, 1);
  result.splice(newIndex, 0, removed);
  return result;
}

const moveElement = (array, index, offset): DragItem[] => {
  const newIndex = index + offset;

  return move(array, index, newIndex);
}

